export default [
    {
        path: '/contacts',
        name: 'contacts',
        component: () => import ('./pages/Contact')
    },
]
